import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-3">焦点专题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">精选深度专题内容，一张图了解一部好作品</p>
        <div className="flex flex-col gap-6">
          {carouselItems.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="group flex flex-col md:flex-row bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-full md:w-[360px] lg:w-[420px] flex-shrink-0 h-48 md:h-auto overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
                <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full whitespace-nowrap w-fit mb-3">
                  {item.tag}
                </span>
                <h3 className="text-lg md:text-xl font-heading text-foreground-900 mb-3">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}